import Vue from 'vue';
import Router from 'vue-router';
import store from '../store/index';

// routers
import Login from './login';
import Home from './home';
import News from './news';
import SiteInfo from './siteInfo';
import Subject from './subject';
import Case from './case';
import Example from './example';
import Expert from './expert';
import Partner from './partner';
import Course from './course';
import UserInfo from './userInfo';
import Member from './member';
import Evaluation from './evaluation';
import Order from './order';
import Refund from './refund';
import Account from './account';
import Config from './config';
import Integral from './integral';
import Recommend from './recommend';
import Product from './product';
import Service from './service';

// view
const Layout = () => import('Components/v-layout');
const NotFoundError = () => import('Views/not-found-error');
const WebMatrixDetail = () => import('Views/webMatrix/webMatrix-detail');

Vue.use(Router);

const defaultIndex = {
  path: '/',
  name: 'index',
  component: Layout,
  children: [
    ...Home,
    ...News,
    ...SiteInfo,
    ...Subject,
    ...Case,
    ...Example,
    ...Expert,
    ...Partner,
    ...Course,
    ...UserInfo,
    ...Member,
    ...Evaluation,
    ...Order,
    ...Refund,
    ...Account,
    ...Config,
    ...Integral,
    ...Recommend,
    ...Product,
    ...Service,
    { path: '*', name: 'NotFoundError', component: NotFoundError },
  ],
};


const Routes = [
  ...Login,
];

let webMatrix = false;

function initRoutes() {
  const hostname = window.location.hostname;
  if (hostname !== 'zkrmkj.com' && hostname !== 'www.zkrmkj.com') {
    Routes.push({ path: '/', name: 'index', component: WebMatrixDetail });
    webMatrix = true;
  } else {
    Routes.push(defaultIndex);
  }
}
initRoutes();

const router = new Router({
  mode: 'history',
  routes: Routes,
});

router.beforeEach((to, from, next) => {
  // console.log(window.location);
  // console.log(to);
  if (webMatrix && to.path !== '/') {
    next('/');
    return;
  }
  store.dispatch('currentMenu', to.path);
  next();
});

router.afterEach(() => {
  window.scrollTo(0, 0);
});

/* 重写路由push方法 解决console输出"定位到相同路径"的警告" */
const routerPush = Router.prototype.push;
Router.prototype.push = function push(location) {
  return routerPush.call(this, location).catch(error => error);
};

export default router;



// WEBPACK FOOTER //
// ./src/router/index.js